import React, { FC } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Theme, makeStyles } from '@material-ui/core';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination
} from '@material-ui/core';
import chaiStringUtils from '../../common/chaiStringUtils.js';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  content: {
    padding: 0
  },
  dialogContent: {
    minWidth: '400px',
  },
  icon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  isFinalContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
  },
}));

type Props = { 
  paging: Paging,
  setPaging: React.Dispatch<React.SetStateAction<Paging>>,
  purchasedTypeHistoryList: PurchasedTypeHistoryInfo[]
}

const PurchasedTypeHistoryTable: FC<Props> = ({ paging, setPaging, purchasedTypeHistoryList }) => {

  const classes = useStyles();
  let totalCount = 0;

  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setPaging({
      ...paging,
      page: page
    });
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaging({
      ...paging,
      rowsPerPage: Number(event.target.value)
    });
  };

  const setTotalCount = (value: number) => {
    totalCount = value;
  }

  return (
    <Card>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">NO.</TableCell>
                  <TableCell align="center">카드번호</TableCell>
                  <TableCell align="center">매출구분</TableCell> 
                  <TableCell align="center">승인금액</TableCell>
                  <TableCell align="center">승인일자</TableCell>  
                  <TableCell align="center">승인번호</TableCell> 
                  <TableCell align="center">가맹점명</TableCell>                           
                </TableRow>
              </TableHead>
              <TableBody>
                {purchasedTypeHistoryList.slice(0, purchasedTypeHistoryList.length).map((item, index) => (
                    <TableRow
                    hover
                    key={index}
                    >
                    <TableCell align="center">{setTotalCount(item.totalCount)}{(index+1)+(paging.page* paging.rowsPerPage)}</TableCell>
                    <TableCell align="center">{item.cardNoMasked}</TableCell>
                    <TableCell align="center">{chaiStringUtils.codeName('salesKindDivisionCode', item.salesKindDivisionCode)}</TableCell>
                    <TableCell align="right">{chaiStringUtils.moneyFormat(item.cardApprovalAmount)}</TableCell>
                    <TableCell align="center">{chaiStringUtils.dateFormatDefault(item.approvalDate)}</TableCell>
                    <TableCell align="center">{item.cardApprovalNo}</TableCell>
                    <TableCell align="center">{item.merchantName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={totalCount}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={paging.page}
          rowsPerPage={paging.rowsPerPage}
          rowsPerPageOptions={[10, 25, 100]}
        />
      </CardActions>
    </Card>
  );
};

export default PurchasedTypeHistoryTable;

